import script from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./MultiStylePanel.vue?vue&type=style&index=0&id=80f1bc4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f1bc4e"]])

export default __exports__